import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userEnterprisesBackend } from './user-enterprises.backend';
import { userEnterprisesReducer } from './user-enterprises.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('userEnterprises', userEnterprisesReducer),
    BackendModule.forFeature('userEnterprises', userEnterprisesBackend),
  ],
})
export class DatastoreUserEnterprisesModule {}
